type PendingApplicantRequestCount = {
  count: number;
};

/**
 * Pending applicant requests, for the badge on the admin navigation.
 *
 * Nothing else tells an AIL admin that an employer has asked for a candidate —
 * no mail is sent and no event fires — so without this the request sits unseen
 * until somebody opens the page on their own initiative.
 *
 * Mirrors `useSupportRequestCount`, which backs the neighbouring badge.
 */
export const useApplicantRequestCount = () => {
  const count = useState<number>("pending-applicant-request-count", () => 0);
  const loading = useState<boolean>("pending-applicant-request-count-loading", () => false);
  const loaded = useState<boolean>("pending-applicant-request-count-loaded", () => false);
  const apiFetch = useApiFetch();

  const load = async (force = false) => {
    if (loading.value || (loaded.value && !force)) {
      return;
    }

    loading.value = true;
    try {
      const response = await apiFetch<PendingApplicantRequestCount>("/employer/applicant-requests/pending-count");
      count.value = response.count;
      loaded.value = true;
    } catch {
      count.value = 0;
      loaded.value = false;
    } finally {
      loading.value = false;
    }
  };

  const reset = () => {
    count.value = 0;
    loaded.value = false;
  };

  return {
    count: readonly(count),
    loading: readonly(loading),
    load,
    reset,
  };
};
